import React from 'react';
import { FormFeedback } from 'reactstrap';

export interface CommonInputProps {
    name: string;
    placeholder: string;
    value: string;
    type?: string;
    min?: string;
    errors: Record<string, string | undefined>;
    validate: boolean;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
}

export default function CommonInput({
    name,
    placeholder,
    value,
    type,
    min,
    errors,
    validate,
    onChange,
    onBlur,
}: CommonInputProps) {
    return (
        <>
            <input
                type={type}
                min={min}
                className={`form-control ${validate && !errors[name] ? "is-valid" : "is-invalid"}`}
                placeholder={placeholder}
                name={name}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
            />
            {errors[name] && <FormFeedback>{errors[name]}</FormFeedback>}
        </>
    );
}